var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showAll)?_c('h3',{staticClass:"pageFlex"},[(_vm.showLine)?_c('span',{style:({backgroundColor: _vm.bgColor})}):_vm._e(),_vm._v(" "+_vm._s(_vm.val)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }